import React from "react";
import { array, bool, oneOf, string } from "prop-types";

import BaseContext from "./BaseContext";

const propTypes = {
  description: string,
  disablePolyfills: bool,
  includeLibs: array,
  keywords: string,
  scope: oneOf(["react", "static"]),
  title: string,
};

const Base = ({
  children,
  title = "",
  description,
  keywords,
  scope: scopeProp = "static",
  disablePolyfills,
  includeLibs = [],
}) => {
  function includeOnlyLibs(files = [], libs = [], disablePolyfills = false) {
    // left all files which
    return files.filter(
      (file) =>
        // don't starts with 'lib/'
        !file.startsWith("lib/") ||
        // or dont't ends on one of lib strings
        libs?.some((lib) => file.endsWith(lib)) ||
        // or is not polyfills when they should be included
        (!disablePolyfills && file.endsWith("polyfills.js"))
    );
  }

  const {
    css = [],
    js = [],
    pages,
    pageId,
    isServer = false,
    scope: scopeContext = "static",
    metaTheme = "#ff5722",
    lang,
  } = React.useContext(BaseContext);

  const scope = scopeProp || scopeContext;

  return isServer ? (
    <html lang={lang}>
      <head>
        <title>
          {title ? `${title} - ` : ""}
          Lighter
        </title>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge, chrome=1" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=yes"
        />
        <meta name="author" content="Lighting Beetle s.r.o." />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="shortcut icon" href="/favicon.ico" />
        <meta name="theme-color" content={metaTheme} />
        {includeOnlyLibs(css, includeLibs, disablePolyfills).map((cssItem) => (
          <link href={cssItem} rel="stylesheet" key={cssItem} />
        ))}
      </head>
      <body>
        <div
          id="root"
          data-lighter-page-id={pageId}
          data-lighter-page-scope={scope}
          {...(pages.length && { "data-lighter-pages": JSON.stringify(pages) })}
        >
          {children}
        </div>
        <div id="root-modals" />
        <div id="root-dropdowns" />
        <div id="root-tooltips" />

        {includeOnlyLibs(js, includeLibs, disablePolyfills)
          .filter((script) =>
            scope === "react" ? !script.match(/static\..*.*js/) : true
          )
          .filter((script) =>
            scope === "static" ? !script.match(/app\..*.*js/) : true
          )
          .map((jsItem) => (
            <script src={jsItem} key={jsItem} />
          ))}
      </body>
    </html>
  ) : (
    children
  );
};

Base.propTypes = propTypes;

export default Base;
